import { Card, CardProps, Collapse } from "@blueprintjs/core";
import { FC, ReactNode } from "react";
import { PrimaryCardHeader } from "./PrimaryCardHeader";
import { UCLColorKey } from "../colors/uclColors";
import classNames from "classnames";

export interface PrimaryCardProps extends CardProps {
  headerContent?: string | ReactNode | undefined;
  hideBody?: boolean;
  columns?: number;
  children?: ReactNode | undefined;
  selected?: boolean;
  onSelect?: () => void;
  color?: UCLColorKey;
}

/**
 * `PrimaryCard` is a wrapper around @blueprintjs/core's `Card` component.
 *
 * This wrapper adds header & body capabilities.
 */
const PrimaryCard: FC<PrimaryCardProps> = ({
  headerContent,
  hideBody,
  columns,
  children,
  selected,
  onSelect,
  color,
  ...cardProps
}) => {
  return (
    <div
      className={classNames(
        "ucl-card ucl-card--primary",
        { "ucl-card--selected": selected },
        { "ucl-card--clickable": !!onSelect },
        color ? `ucl-card--color-${color}` : null
      )}
      onClick={onSelect}
    >
      <Card {...cardProps}>
        {!!headerContent &&
          (typeof headerContent === "string" ||
            headerContent instanceof String) && (
            <PrimaryCardHeader label={headerContent as string} />
          )}
        {!!headerContent &&
          !(
            typeof headerContent === "string" || headerContent instanceof String
          ) && <section className="ucl-card-header ucl-card__header">{headerContent}</section>}
        <Collapse isOpen={!hideBody}>
          <div
            className={`ucl-card__body ucl-card__body--primary ${
              columns ? "ucl-grid ucl-grid-" + columns : ""
            }`}
          >
            {children}
          </div>
          <div className="ucl-card__footer-block"></div>
        </Collapse>
      </Card>
    </div>
  );
};

export default PrimaryCard;
